module.exports = __webpack_public_path__ + "static/media/iconStudent.b62849db.svg";